import { Box } from "@mui/material";
import EntityEssentialInfo from "./EntityEssentialInfo";
import EntityMetadataAccordingToType from "./EntityMetadataAccordingToType";
import EntityTags from "./EntityTags";
import EntityStatsAccordingToType from "./EntityStatsAccordingToType";

const TabContainorBasic = ({ editableEntityData, setEditableEntityData, artists, global_constant, createQuestions }) => {
    return (
        <Box sx={styles.containerStyleRow_sx}>
            <EntityEssentialInfo editableEntityData={editableEntityData} setEditableEntityData={setEditableEntityData} global_constant={global_constant} createQuestions={createQuestions} />
            <EntityMetadataAccordingToType editableEntityData={editableEntityData} setEditableEntityData={setEditableEntityData} artists={artists} global_constant={global_constant} />
            <EntityStatsAccordingToType editableEntityData={editableEntityData} setEditableEntityData={setEditableEntityData} artists={artists} global_constant={global_constant} />
            <EntityTags editableEntityData={editableEntityData} setEditableEntityData={setEditableEntityData} editableEntityTagsData={editableEntityData?.tags} geners_type={global_constant?.tags} />
        </Box>
    );
}

const styles = {
    containerStyleRow_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        borderRadius: 1,
        border: '1px solid #000000',
        padding: 2,
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2,
        m: 4
    },
    containerStyleColumn_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2,
    },
    containerStyleRowWithoutBorderNoColor_sx: {
        //backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "row",
        gap: 2
    },
}

export default TabContainorBasic;